/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["html[_ngcontent-%COMP%]{margin-left:0}header[_ngcontent-%COMP%]{z-index:55;position:fixed;max-width:initial;padding:0}header[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{max-width:960px;position:relative;display:block;margin:0 auto;padding:0 30px}section[_ngcontent-%COMP%]{margin-top:50px;width:900px;text-align:center;border:1px solid #ccc;margin-left:auto;margin-right:auto}.hide[_ngcontent-%COMP%]{visibility:hidden}"];
export { styles as styles };
